// Figure notes describe the original assets. They are shared across collection views.
const notes = {
  scrollytelling: [
    ['Demand through the day', 'An hourly heatmap introduces when demand concentrates, before the story turns to supply.'],
    ['Demand and generation', 'The relationship between electricity demand and generation develops in a shared chart.'],
    ['Capacity and distance', 'The scatterplot lets the reader compare substation distance with generation capacity.'],
    ['Regional exposure', 'A map places reliance on peaker plants in its geographic context.'],
    ['Environmental costs', 'The closing comparison brings several environmental costs into the same story.'],
  ],
  stride: [
    ['The conversation', 'The assistant can recommend products while the selected order remains visible beside the conversation.'],
    ['Model and tools', 'The orchestration layer connects the conversation, retrieval and sentiment analysis to five MCP tool servers.'],
    ['Order context', 'Selecting a current order gives the next question a concrete purchase to refer to.'],
    ['Earlier purchases', 'Past orders remain available when a support question concerns an earlier delivery.'],
  ],
  dealtracker: [
    ['New matches', 'The digest brings together newly relevant products with prices, discounts and direct links.', false],
    ['Another retailer', 'The same email format accommodates a different retailer’s listings after their data has been normalised.', false],
  ],
  lexaday: [
    ['se', 'Apart, as in seclude and secede.'],
    ['a/c/d', 'To, toward, near, as in accelerate, accessible and admittance.'],
    ['dict', 'Speak, as in dictate, contradict and prediction.'],
    ['miss, mit', 'Send, let go, as in dismiss, emit and missile.'],
    ['The daily lesson', 'The email combines the new root, related words, examples and reviews due for that learner.', false],
  ],
  early: [
    ['Podcast downloader', 'A tool for collecting Scientific American podcast episodes.'],
    ['Browser extensions', 'Experiments with changing how pages behave and adding new browser tools.'],
    ['Music downloader', 'A desktop interface for finding and downloading music.'],
    ['Game automation', 'A script recognises the cards, computes an expression and enters the answer.'],
    ['Econographer', 'A Word add-in for drawing economics diagrams directly in a document.'],
  ],
};

export function projectFigures(entry) {
  if (!entry || entry.mediaMode === 'logo') return [];
  return (entry.media || []).map((src, index) => {
    const [label, caption, fit = true] = notes[entry.id]?.[index] || [`Figure ${index + 1}`, ''];
    return {
      src: entry.mediaMode === 'hero' || fit === false ? src : src.replace('/assets/img/', '/assets/img/gallery-thumbs/') + '.webp',
      fullSrc: src,
      alt: `${entry.title}, ${label}`,
      label,
      caption,
      fit,
    };
  });
}
